/**
 * Merges two arrays of objects by their ID field, with items from the second array
 * taking precedence over items from the first array when IDs match.
 * Properties are merged, not replaced entirely.
 */
export const mergeById = <T extends { id: unknown }>(
  existing: T[],
  updated: T[],
): T[] => {
  const itemsMap = new Map<unknown, T>();

  // Add existing items
  existing.forEach((item) => {
    if (item.id != null) {
      itemsMap.set(item.id, item);
    }
  });

  // Merge/overwrite with updated items
  updated.forEach((item) => {
    if (item.id != null) {
      const existingItem = itemsMap.get(item.id);
      if (existingItem) {
        // Merge properties, with updated item properties taking precedence
        itemsMap.set(item.id, { ...existingItem, ...item } as T);
      } else {
        // Add new item
        itemsMap.set(item.id, item);
      }
    }
  });

  return Array.from(itemsMap.values());
};
